




















































import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';

@Component({ name: 'SecondaryWalletTypeSettingsRead' })
export default class extends SaascadaVue {

    get currentWallet() {
        return DepositAccountModule.currentDepositAccountWallet;
    }

    get isGeneralSettingsAvailable() {
        return this.currentWallet.walletSettings?.generalSettings;
    }

}
